import { render, staticRenderFns } from "./supplierSearchDialog.vue?vue&type=template&id=04b96791"
import script from "./supplierSearchDialog.vue?vue&type=script&lang=js"
export * from "./supplierSearchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports